import React, { createContext, useContext, useState, ReactNode } from 'react';

interface FancoinContextType {
  balance: number;
  addFancoins: (amount: number) => void;
  deductFancoins: (amount: number) => void;
}

const FancoinContext = createContext<FancoinContextType | undefined>(undefined);

export function FancoinProvider({ children }: { children: ReactNode }) {
  const [balance, setBalance] = useState(0);

  const addFancoins = (amount: number) => setBalance((prev) => prev + amount);
  const deductFancoins = (amount: number) => setBalance((prev) => prev - amount);

  return (
    <FancoinContext.Provider value={{ balance, addFancoins, deductFancoins }}>
      {children}
    </FancoinContext.Provider>
  );
}

export const useFancoin = () => {
  const context = useContext(FancoinContext);
  if (context === undefined) {
    throw new Error('useFancoin must be used within a FancoinProvider');
  }
  return context;
};
